import { api } from './api';

const getCustomerUserList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `CustUsers/getCustomerUserList`,
        method: 'GET',
        params: {
            Page: pageNumber,
            pageSize,
            ...body,
        },
    });
    return response.data;
};

const getCustomerList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `CustUsers/getCustomerList`,
        method: 'GET',
        params: {
            Page: pageNumber,
            pageSize,
            ...body,
        },
    });
    return response.data;
};

const deleteCustomerUser = async (id) => {
    const response = await api({
        url: `CustUsers/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const getCustomerUserByFilterList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `CustUsers/getCustomerUserListByFilter`,
        method: 'GET',
        params: {
            Page: pageNumber,
            PageSize: pageSize,
            ...body,
        },
    });
    return response.data;
};

const custUsersServices = {
  getCustomerUserList,
  getCustomerList,
  deleteCustomerUser,
  getCustomerUserByFilterList,
};

export default custUsersServices;
